<template>
    <a class="box kanban-card" @click="$emit('select')" @dblclick="open_note">
        <div class="columns kanban-card-header">
            <div class="column">
                <b class="card-title">{{card.note.name || 'Untitled Note'}}</b>
                <div v-if="loading" class="loader is-pulled-right"></div>
            </div>

            <div v-if="card.assignees.length > 0" class="column is-narrow assignees">
                <avatar
                    :user="card.assignees[0].user"
                    class="is-24x24 avatar"/>

                <avatar
                    v-if="card.assignees.length === 2"
                    :user="card.assignees[1].user"
                    class="is-24x24 avatar"/>

                <div v-else-if="card.assignees.length > 2" class="badge">
                    +{{card.assignees.length - 1}}
                </div>
            </div>
        </div>

        <note-tags :tags="card.note.note_tags" class="note-tags"/>

        <div class="has-text-grey-light">
            <base-datetime :date="card.created_at"/> &nbsp;

            <span v-if="card.due_date" :class="{'has-text-danger': overdue}">
                <i class="far fa-clock"></i>&nbsp;
                <span :title="card.due_date">{{due_date}}</span>
            </span>
        </div>

    </a>
</template>

<script>
import moment from 'moment';
import Avatar from '../common/Avatar.vue';
import NoteTags from '../note/NoteTags.vue';
import { open_in_topic } from '../../utils/helpers';

export default {
    components: { NoteTags, Avatar },
    props: ['space', 'card'],
    data() {
        return { loading: false };
    },
    computed: {
        due_date() {
            return moment(this.card.due_date).fromNow();
        },
        overdue() {
            return moment(this.card.due_date) < moment();
        },
    },
    methods: {
        async open_note() {
            this.loading = true;
            const note = await this.$store.dispatch('notes/detail', {
                space_id: this.space.id,
                note_id: this.card.note.id,
            });

            open_in_topic(this.space.id, note.topic.id, note.path, note.id);
            this.loading = false;
        },
    },
};
</script>

<style scoped>
    .kanban-card {
        margin: 0.5rem;
        padding: 0.8rem;
        border-radius: 0.2rem;
    }

    .kanban-card-header {
        margin-bottom: 0;
    }

    .assignees {
        margin-top: -0.5rem;
    }

    .avatar {
        float: left;
        margin: 0.2rem;
    }

    .badge {
        height: 24px;
        width: 24px;
        float: left;
        border-radius: 50%;
        background: #c2c2c2;
        color: white;
        font-weight: bold;
        text-align: center;
        padding-top: 0.3rem;
        margin: 0.2rem;
        font-size: 0.8rem;
    }

    .note-tags {
        margin: 0;
    }
</style>
